import React, { useCallback, useContext } from "react";
import { useHistory } from "react-router-dom";

import { ReactComponent as FellowWordmark } from "~/legacy-assets/images/logos/fellow-wordmark-black-solid.svg";
import { AuthContext } from "~/lib/auth";
import { Link } from "~/ui/legacyFellowIndex";

import { Button } from "../components";

import styles from "../css/DesktopSplash.module.css";

const DesktopSplash = () => {
	const history = useHistory();
	const authContext = useContext(AuthContext);

	const openLoginPage = useCallback(() => {
		window.open("/auth/login/?redirectBackToDesktopOnLastOauthStep=1");
	}, []);

	const openSignupPage = useCallback(() => {
		window.open("/auth/signup/?redirectBackToDesktopOnLastOauthStep=1");
	}, []);

	const onWindowMessage = useCallback(
		(event: MessageEvent) => {
			if (event.data?.channel === "identity.auth") {
				if (event.origin !== window.ROOT_URL && event.origin !== window.location.origin) {
					console.warn(
						`Received message from invalid origin. Expected ${window.ROOT_URL}, received ${event.origin}`,
						event.data,
					);
					return;
				}
				const { data } = event;

				window.setTimeout(() => {
					if (data.signup?.redirect) {
						window.location.href = data.signup.redirect;
					} else if (data.signup?.next) {
						authContext.setAuthContext(data.signup);
						history.push(data.signup.next, data);
					} else if (data.next) {
						window.location.replace(data.next);
					} else {
						history.push("/");
					}
				}, 100);
			}
		},
		[history, authContext],
	);
	window.addEventListener("message", onWindowMessage);

	return (
		<div className={styles.fullPageContainer}>
			<div className={styles.ringsContainer}></div>
			<div className={styles.contentContainer}>
				<FellowWordmark className={styles.wordMark} />
				<div className={styles.mainText}>Your meeting problem, solved.</div>
				<div className={styles.flexContainer}>
					<Button primary onClick={openLoginPage} className={styles.loginButton}>
						Log in to Fellow
					</Button>
					<div className={styles.supportingText}>
						We&apos;ll take you to your web browser to sign in and then bring you back here.
					</div>
				</div>
				<div className={styles.signupText}>
					Don&apos;t have a Fellow account?{" "}
					<Link onClick={openSignupPage} className={styles.signupButton}>
						Sign up
					</Link>
				</div>
			</div>
		</div>
	);
};
export default DesktopSplash;
